import React, { useCallback } from "react";
import PropTypes from "prop-types";

import { faGripVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useDragDropContext } from "scenes/Hubly/components/Workspace/components/WorkflowContainer/components/WorkflowEditor/hooks";

export function Layout({
  addingMode,
  taskCheckbox,
  taskTitle,
  taskDetailsContent,
  assignedAdvisor,
  editMode,
  leftSideMinWidth,
  disableHover,
  children,
  taskForm,
  ...props
}) {
  const [{ isDragging, disabled: disableDnd }] = useDragDropContext();
  const assignedAdvisorMarginLeft = assignedAdvisor ? "0.5em" : 0;

  const getCursor = useCallback(() => {
    if (disableDnd) return "no-drop";
    return isDragging ? "grabbing" : "grab";
  }, [disableDnd, isDragging]);

  return (
    <div {...props} className={disableHover ? "" : "root_only_grey_on_hover"}>
      <div
        className={disableHover ? "" : "grey_on_hover"}
        style={{
          display: "flex",
          flexFlow: "row",
          alignItems: "center",
          marginLeft: "2px",
        }}
      >
        <div
          style={{
            minWidth: leftSideMinWidth,
            display: "flex",
            flexFlow: "row",
            alignItems: "center",
            flexGrow: "1",
          }}
        >
          {!disableHover && !addingMode ? (
            <div
              style={{
                alignSelf: "flex-start",
                marginTop: "0.1em",
              }}
            >
              <FontAwesomeIcon
                className="dark_grey_on_hover task-drag-handle"
                color="rgb(218, 218, 218)"
                icon={faGripVertical}
                style={{
                  marginLeft: "0.5em",
                  cursor: getCursor(),
                }}
              />
            </div>
          ) : (
            <div style={{ width: "1.1em" }} />
          )}
          <div
            style={{
              flexGrow: 1,
              display: "flex",
              flexFlow: "row",
              marginLeft: taskCheckbox ? "0.5em" : 0,
              alignItems: "center",
            }}
          >
            {!editMode && (
              <div style={{ marginTop: "0.3em", marginLeft: "0.25em" }}>
                {taskCheckbox}
              </div>
            )}
            {!editMode && (
              <div
                style={{
                  alignSelf: "flex-start",
                  marginLeft: assignedAdvisorMarginLeft,
                  marginTop: assignedAdvisor && addingMode ? "0.4em" : 0,
                }}
              >
                {assignedAdvisor}
              </div>
            )}
            <div style={{ marginLeft: "0.4em", flexGrow: 1 }}>{taskTitle}</div>
          </div>
        </div>
        {!editMode && children && (
          <div style={{ minWidth: 144, display: "flex" }}>{children}</div>
        )}
      </div>
      {taskForm && (
        <div
          style={{
            marginTop: ".5em",
            marginLeft: "2em",
            marginBottom: "1.5em",
          }}
        >
          {taskForm}
        </div>
      )}
      <div
        className="taskDescriptionDiv"
        style={{
          marginTop: "0.25em",
          marginLeft: "5em",
          marginRight: "2em",
        }}
      >
        {taskDetailsContent}
      </div>
    </div>
  );
}

Layout.propTypes = {
  taskCheckbox: PropTypes.node,
  taskTitle: PropTypes.node,
  assignedAdvisor: PropTypes.node,
  editMode: PropTypes.bool,
  leftSideMinWidth: PropTypes.number,
  taskDetailsContent: PropTypes.node,
  disableHover: PropTypes.bool,
  addingMode: PropTypes.bool,
  children: PropTypes.node,
  taskForm: PropTypes.node,
};

Layout.defaultProps = {
  addingMode: false,
  taskCheckbox: null,
  taskTitle: null,
  assignedAdvisor: null,
  editMode: false,
  leftSideMinWidth: 75,
  disableHover: false,
  children: null,
  taskDetailsContent: null,
  taskForm: null,
};

export default Layout;
